// extracted by mini-css-extract-plugin
export default {"wrap":"QG-z","subtitle":"RG-z","contentWrap":"SG-z","imgWrap":"TG-z","heading":"UG-z","copy":"VG-z"};